import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";
import configureApiRestService from "../../services/apiService";
import { login, loginCookie, modulesCookie, removeloginCookie, rolCookie, setValidationMainModules, tenantCookie  } from "../../services/auth";
import { setActivePortalSession, shouldConfirmPortalTransfer } from "../../services/portalSession";
import { serverMessages, serverMessagesLogin, serverMessagesNoOpenNotification } from "../serverMessages";
import { setMessageResponse, toggleLoadingIndicator, toggleShowMyUser } from "../system/actions";
import { MessageResponse } from "../system/types";
import { AppThunk } from "../thunks";
import { getActiveGroupAPI, getActiveSpecialityAPI, getAllModuleTokenWithUserAPI, getAllTableUserAPI, getGroupModuleAPI,  getRecoverPasswordAPI,  getUserAssociatedAPI,  getUserInfoByTokenAPI,  getUserOdontologicoAPI,  postLoginAPI, postRegisterUserAsyncAPI, postOnboardingRegisterAPI, updatepasswordAPI, updateStatusUserAsyncAPI, updateUserAsyncAPI ,getPathologicalHistoryAPI, getStatusOrganizationAPI,getCIE10ByFilterAPI, getValidateTokenAPI, putUpdatePasswordUserAPI, getSytemByTokenAPI, getUserInformationAPI, getSytemByUserIdAPI, getModulesAPI, getContractsExpiringAPI, getContractSalesDocumentsAPI, getOrganizationLegalDocumentsAPI, getLegalDocumentsAPI, getAllLegalDocumentsAPI, postLegalDocumentAPI, putLegalDocumentAPI, getSalesDocumentsAPI, getOrganizationClientDataAPI, postContractSalesDocumentAPI, postContractAPI, prepareContractPayPhonePaymentAPI, confirmContractPayPhonePaymentAPI, preparePublicPayPhoneTrialAPI, preparePublicPayPhoneTrialFromBridgeAPI, confirmPublicPayPhoneTrialAPI, confirmPublicPayPhonePaymentAPI, getPendingPaymentRequestInvoicesAPI, getOrganizationPaymentRequestsAPI, getPendingCardValidationRequestsAPI, regeneratePaymentRequestPayPhoneAPI, postPaymentRequestSalesDocumentAPI, reversePaymentRequestPayPhoneAPI, cancelContractAPI, cancelSalesDocumentAPI, getOrganizationPaymentMethodAPI, getExpenseCategoriesAPI, postExpenseCategoryAPI, putExpenseCategoryAPI, getExpensesAPI, postExpenseAPI, putExpenseAPI, cancelExpenseAPI, getExpenseDocumentAPI, getFinancialMetricsAPI, getExpenseOptionsAPI, getClientDataAPI, searchOrganizationsAPI, getPlansAPI, getPlanByCodeAPI, postPlanAPI, putPlanAPI, getRolSystemsAPI, getServicesAPI, getProfileAPI, postSpecialityAPI, putSpecialityAPI, getMedicalRecordSectionsAPI, postMedicalRecordSectionAPI, putMedicalRecordSectionAPI, putSpecialityDefaultSectionsAPI, getTbcRolSystemsAPI, getTbcUsersAPI, postTbcUserAPI, putTbcUserAPI, getCompanyUsersAPI, postCompanyUserAPI, putCompanyUserAPI} from "./restCallUser";
import { CatalogProductManagementRequest, ContractSalesDocumentRequest, CredentialsRequest, MainModuleDataType, ManagedService, OrganizationProductRequest, PlanRequest, ProductPackageRequest, UpdateOrganizationProductRequest, UserLoginState } from "./types";
import {
    getCatalogProductsAPI,
    getProductPackagesAPI,
    getProductsAPI,
    postCatalogProductAPI,
    postOrganizationProductAPI,
    postProductPackageAPI,
    putCatalogProductAPI,
    putOrganizationProductAPI,
    putProductPackageAPI
} from "./restCallUser";
import {
    getServicesForManagementAPI,
    postServiceAPI,
    putServiceAPI
} from "./restCallUser";
import {
    confirmOrganizationCardTokenPayPhoneAPI,
    disableOrganizationCardTokenAPI,
    getActiveOrganizationCardTokenAPI,
    getOrganizationCardTokensAPI,
    chargeContractWithCardTokenAPI,
    prepareOrganizationCardTokenPayPhoneAPI
} from "./restCallUser";
import {
    getOrganizationManagementCentersAPI,
    getOrganizationCenterSpecialitiesAPI,
    getOrganizationManagementInventoryMovementReasonsAPI,
    getOrganizationManagementInventoryMovementsAPI,
    getOrganizationManagementOrganizationsAPI,
    getOrganizationManagementContractAPI,
    getContractBillingDocumentsAPI,
    postContractBillingDocumentAPI,
    putContractBillingDocumentAPI,
    deleteContractBillingDocumentAPI,
    getContractBillingDocumentFileAPI,
    getContractBillingPaymentsAPI,
    postContractBillingPaymentAPI,
    putContractBillingDocumentMoraAPI,
    deleteContractBillingPaymentAPI,
    getContractBillingPaymentFileAPI,
    getContractDocumentsAPI,
    postContractDocumentAPI,
    deleteContractDocumentAPI,
    getContractDocumentFileAPI,
    postContractBillingDueEvaluationAPI,
    getContractBillingMetricsAPI,
    putContractBillingSalesDocumentAPI,
    getOrganizationManagementPlanAPI,
    getOrganizationManagementStaffAPI,
    getOrganizationManagementStaffRolesAPI,
    getOrganizationManagementStaffAuditAPI,
    getOrganizationMedicalFeesAPI,
    postOrganizationMedicalFeeAPI,
    putOrganizationMedicalFeeAPI,
    deleteOrganizationMedicalFeeAPI,
    getOrganizationManagementProductsAPI,
    getOrganizationManagementSpecialitiesAPI,
    getOrganizationManagementWarehouseStockAPI,
    getOrganizationManagementWarehousesByCenterAPI,
    postOrganizationManagementCenterAPI,
    postOrganizationManagementInventoryMovementAPI,
    postOrganizationManagementStaffAPI,
    putOrganizationManagementStaffAPI,
    postOrganizationManagementWarehouseAPI,
    putOrganizationManagementCenterAPI,
    putOrganizationManagementContractAPI,
    putOrganizationCenterSpecialityAPI,
    putOrganizationManagementSpecialityAPI,
    putOrganizationManagementWarehouseAPI
} from "./restCallUser";
import {
    getOrganizationProcedureDocumentsAPI,
    getOrganizationProcedureDocumentFileAPI,
    postOrganizationProcedureDocumentAPI,
    putOrganizationProcedureDocumentAPI,
    inactivateOrganizationProcedureDocumentAPI
} from "./restCallUser";
import { getAppointmentsByOrganizationAPI, getMedicScheduleByUserAPI, getOrganizationMedicByIdAPI, getOrganizationMedicsAPI } from "./restCallUser";
import {
    deleteMedicScheduleAPI,
    deleteScheduleExceptionAPI,
    getReasonsScheduleExceptionsAPI,
    getWeekDaysAPI,
    postMedicScheduleAPI,
    postScheduleExceptionAPI,
    putMedicScheduleAPI,
    putScheduleExceptionAPI
} from "./restCallUser";
import { putOrganizationAPI } from "./restCallUser";
import {
    deleteGlobalDocumentTypeAPI,
    getGlobalDocumentTypesAPI,
    getProcedureDocumentTemplateTagsAPI,
    getGlobalPhysicalSpaceTypesAPI,
    inactivateGlobalPhysicalSpaceTypeAPI,
    postGlobalDocumentTypeAPI,
    postGlobalPhysicalSpaceTypeAPI,
    putGlobalDocumentTypeAPI,
    putGlobalPhysicalSpaceTypeAPI
} from "./restCallUser";
import { postUserAppointmentAPI, putAppointmentStatusAPI } from "./restCallUser";


//

const normalizePortalUrl = (url?: string | null) => (url || "").trim().replace(/\/$/, "");

const isExternalPortalModule = (value: MainModuleDataType) => {
    const modulePortalUrl = normalizePortalUrl(value.url);
    const currentPortalUrl = normalizePortalUrl(process.env.REACT_APP_API_BASE_URL_Portal);

    return value.portal === true && !!modulePortalUrl && modulePortalUrl !== currentPortalUrl;
};

const getMainModuleRedirectUrl = (value: MainModuleDataType) => {
    if (isExternalPortalModule(value)) {
        return value.url;
    }

    const urlModule = normalizePortalUrl(value.urlModule);
    return urlModule ? `${process.env.REACT_APP_BASE_URL as string}/${urlModule}` : process.env.REACT_APP_BASE_URL as string;
};

const getInvalidMainModuleMessage = (value: MainModuleDataType) => {
    if (!value.id || !value.xTenant || !value.rolId) {
        return "No se pudo iniciar sesion porque falta informacion del modulo asignado.";
    }

    if (value.portal === true && !normalizePortalUrl(value.url)) {
        return "No se pudo iniciar sesion porque falta la URL del portal asignado.";
    }

    return null;
};

const confirmSingleModuleTransfer = (value: MainModuleDataType) => {
    if (value.portal !== true || !normalizePortalUrl(value.url)) {
        return true;
    }

    if (!shouldConfirmPortalTransfer({
        tenant: value.xTenant,
        moduleId: value.id,
        rolId: value.rolId,
        portalUrl: value.url,
        portalName: value.label || value.description,
    })) {
        return true;
    }

    return window.confirm(
        `Ya tienes una sesion iniciada. Si continuas, se transferira a ${value.label || value.description || 'este portal'} y las otras pestanas se cerraran o volveran al inicio.`
    );
};
const activateMainModuleSession = (value: MainModuleDataType) => {
    tenantCookie(value.xTenant);
    modulesCookie(value.id);
    rolCookie(value.rolId);
    setActivePortalSession({
        tenant: value.xTenant,
        moduleId: value.id,
        rolId: value.rolId,
        portalUrl: value.url,
        portalName: value.label || value.description,
    });
};

export const putUpdatePasswordUser = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putUpdatePasswordUserAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizado", "Contraseña actualizada")
        return responseData.Response
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getValidateToken = (value: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getValidateTokenAPI(value);
    if (responseData.Error !== null) {
        window.location.replace(process.env.REACT_APP_BASE_URL as string);

    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        if (responseData.Response && Object.prototype.hasOwnProperty.call(responseData.Response, 'cardToken')) {
            return responseData.Response.cardToken;
        }
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getCIE10ByFilter= (filter:string, value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getCIE10ByFilterAPI(filter, value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getStatusOrganization = (): AppThunk => async (dispatch) => {
    dispatch(setMessageResponse(null));
    const responseData = await getStatusOrganizationAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {           
        dispatch(setMessageResponse(null));
        if(responseData.Response.status != "ACTIVO"){
            removeloginCookie();
              window.location.replace(process.env.REACT_APP_BASE_URL as string+"/error-server");
        }

        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getPathologicalHistory = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPathologicalHistoryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getUserInfoByToken = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getUserInfoByTokenAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getUserOdontologico = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getUserOdontologicoAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getUserAssociated = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getUserAssociatedAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const updatepassword = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await updatepasswordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizar","Proceso ejcutado"); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getRecoverPassword = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getRecoverPasswordAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getActiveSpeciality = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getActiveSpecialityAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postSpeciality = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postSpecialityAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso", "Especialidad registrada");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putSpeciality = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putSpecialityAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizar", "Especialidad actualizada");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getMedicalRecordSections = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getMedicalRecordSectionsAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postMedicalRecordSection = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postMedicalRecordSectionAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso", "Seccion registrada");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putMedicalRecordSection = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putMedicalRecordSectionAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizar", "Seccion actualizada");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putSpecialityDefaultSections = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putSpecialityDefaultSectionsAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizar", "Secciones por defecto actualizadas");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getActiveGroup = (value:string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getActiveGroupAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const getAllTableUser = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllTableUserAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postRegisterUserAsync = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await postRegisterUserAsyncAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Usuario "+validateMessages.registerSuccess); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postOnboardingRegister = (value:Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postOnboardingRegisterAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Registro", "Organizacion registrada correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const updateUserAsync = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));    
    const responseData = await updateUserAsyncAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizar","Usuario "+validateMessages.updateSuccess); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const updateStatusUserAsync = (value:Object): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    
    const responseData = await updateStatusUserAsyncAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
          
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualizar","Usuario "+validateMessages.updateSuccess); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const postLogin = (accountLoginState: CredentialsRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postLoginAPI(accountLoginState);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessagesNoOpenNotification(responseData);
        dispatch(setMessageResponse(message));
    } else if (responseData.StatusCode === 200) {
        //getSytemByTokenAPI
        const tokenRequest = {
            token: responseData.Response.access_token
        }
        const responseDataRequest = await getSytemByTokenAPI(tokenRequest);
        if (responseDataRequest.Error !== null) {
            window.location.replace(process.env.REACT_APP_BASE_URL as string);
        } else if (responseDataRequest.StatusCode === 200) {
            const mainModules: MainModuleDataType[] = responseDataRequest.Response;
            loginCookie(responseData.Response.access_token);
            if (mainModules.length === 1) {
                setValidationMainModules("NO");
                const singleModule = mainModules[0];
                const invalidMainModuleMessage = getInvalidMainModuleMessage(singleModule);

                if (invalidMainModuleMessage) {
                    const message: MessageResponse = {
                        code: 400,
                        message: [invalidMainModuleMessage]
                    };
                    dispatch(setMessageResponse(message));
                    openNotification("Advertencia", invalidMainModuleMessage);
                    dispatch(toggleLoadingIndicator(false));
                    return;
                }

                if (!confirmSingleModuleTransfer(singleModule)) {
                    dispatch(toggleLoadingIndicator(false));
                    return;
                }

                activateMainModuleSession(singleModule);
                configureApiRestService();
                dispatch(setMessageResponse(null));
                window.location.replace(getMainModuleRedirectUrl(singleModule));
            } else {
                dispatch(setMessageResponse(null));
                setValidationMainModules("SI");
                window.location.replace(`${process.env.REACT_APP_BASE_URL as string}/main-modules`);
            }
        }
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getSytemByUserId = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const userResponse = await getUserInformationAPI()
    const responseData = await getSytemByUserIdAPI(userResponse.Response.id);
    if (responseData.Error !== null) {
        window.location.replace(process.env.REACT_APP_BASE_URL as string);
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getProfile = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getProfileAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getOrganizationMedics = (organizationId?: string | null): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationMedicsAPI(organizationId);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getOrganizationMedicById = (userId: string, organizationId?: string | null): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationMedicByIdAPI(userId, organizationId);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAppointmentsByOrganization = (organizationId?: string | null): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAppointmentsByOrganizationAPI(organizationId);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postUserAppointment = (value: Object, notify: boolean = true): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postUserAppointmentAPI(value);

    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode >= 200 && responseData.StatusCode < 300) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        if (notify) {
            openNotification("Cita", "La cita fue agendada correctamente");
        }
        return responseData.Response ?? true;
    }

    dispatch(toggleLoadingIndicator(false));
};

export const cancelAppointment = (id: string): AppThunk => async (dispatch) => {
    const responseData = await putAppointmentStatusAPI({ Id: id, Status: 'CANCELADO' });

    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    } else if (responseData.StatusCode >= 200 && responseData.StatusCode < 300) {
        return responseData.Response ?? true;
    }

    return undefined;
};

export const getMedicScheduleByUser = (userId: string, organizationId?: string | null): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getMedicScheduleByUserAPI(userId, organizationId);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getWeekDays = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getWeekDaysAPI();
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postMedicSchedule = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postMedicScheduleAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode >= 200 && responseData.StatusCode < 300) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Horario", "Horario creado correctamente");
        return responseData.Response ?? true;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putMedicSchedule = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putMedicScheduleAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode >= 200 && responseData.StatusCode < 300) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Horario", "Horario actualizado correctamente");
        return responseData.Response ?? true;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const deleteMedicSchedule = (id: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteMedicScheduleAPI(id);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode >= 200 && responseData.StatusCode < 300) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Horario", "Horario eliminado correctamente");
        return responseData.Response ?? true;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getReasonsScheduleExceptions = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getReasonsScheduleExceptionsAPI();
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postScheduleException = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postScheduleExceptionAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode >= 200 && responseData.StatusCode < 300) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Bloqueo de agenda", "Bloqueo guardado correctamente");
        return responseData.Response ?? true;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putScheduleException = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putScheduleExceptionAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode >= 200 && responseData.StatusCode < 300) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Bloqueo de agenda", "Bloqueo actualizado correctamente");
        return responseData.Response ?? true;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const deleteScheduleException = (id: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteScheduleExceptionAPI(id);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode >= 200 && responseData.StatusCode < 300) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Bloqueo de agenda", "Bloqueo eliminado correctamente");
        return responseData.Response ?? true;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postLoginToken = (accountLoginState: CredentialsRequest, urlModule: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    configureApiRestService();

    const responseData = await postLoginAPI(accountLoginState);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        // Keep a local fallback only when the shared-domain cookie cannot work on the current host.
        const configuredCookieDomain = (process.env.REACT_APP_DOMAIN_COOKIE ?? '').replace(/^\./, '').toLowerCase();
        const currentHost = window.location.hostname.toLowerCase();
        const cookieDomainMatches = !configuredCookieDomain
            || currentHost === configuredCookieDomain
            || currentHost.endsWith(`.${configuredCookieDomain}`);
        if (!cookieDomainMatches) {
            login(responseData.Response.access_token);
        }
        loginCookie(responseData.Response.access_token);
        window.location.replace(process.env.REACT_APP_BASE_URL as string + "/" + urlModule);
        dispatch(setMessageResponse(null));
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllModuleToken = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getGroupModuleAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {   
        dispatch(setMessageResponse(null));  
        dispatch(toggleLoadingIndicator(false));   
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const toogleMyUser = (value: boolean): AppThunk => async (dispatch) => {
    dispatch(toggleShowMyUser(value));
}
export const getModules = (value: string, value2: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getModulesAPI(value, value2);
    if (responseData.Error !== null) {
        window.location.replace(process.env.REACT_APP_BASE_URL as string);

    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getContractsExpiring = (days?: number | null, organizationId?: string, status?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getContractsExpiringAPI(days, organizationId, status);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const searchOrganizations = (value: string, take: number = 20): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await searchOrganizationsAPI(value, take);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getPlans = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPlansAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getPlanByCode = (code: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPlanByCodeAPI(code);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getRolSystems = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getRolSystemsAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getTbcRolSystems = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getTbcRolSystemsAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getTbcUsers = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getTbcUsersAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postTbcUser = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postTbcUserAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Usuario", "Usuario registrado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putTbcUser = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putTbcUserAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Usuario", "Usuario actualizado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getCompanyUsers = (organizationId?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getCompanyUsersAPI(organizationId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postCompanyUser = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postCompanyUserAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Persona", "Persona registrada correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putCompanyUser = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putCompanyUserAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Persona", "Persona actualizada correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getServices = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getServicesAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getServicesForManagement = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getServicesForManagementAPI();
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postService = (value: ManagedService): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postServiceAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Servicio", "Servicio registrado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putService = (value: ManagedService): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putServiceAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Servicio", "Servicio actualizado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getProducts = (serviceId: string | undefined, searchBy: string, search: string): AppThunk => async (dispatch) => {
    dispatch(setMessageResponse(null));
    const responseData = await getProductsAPI(serviceId, searchBy, search);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        return responseData.Response;
    }
};

export const getCatalogProducts = (serviceId: string | undefined, searchBy: string, search: string): AppThunk => async (dispatch) => {
    dispatch(setMessageResponse(null));
    const responseData = await getCatalogProductsAPI(serviceId, searchBy, search);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        return responseData.Response;
    }
};

export const postCatalogProduct = (value: CatalogProductManagementRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postCatalogProductAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Catálogo", "Producto global registrado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putCatalogProduct = (value: CatalogProductManagementRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putCatalogProductAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Catálogo", "Producto global actualizado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postOrganizationProduct = (value: OrganizationProductRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postOrganizationProductAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Producto", "Producto registrado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putOrganizationProduct = (value: UpdateOrganizationProductRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putOrganizationProductAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Producto", "Producto actualizado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getProductPackages = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getProductPackagesAPI();
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postProductPackage = (value: ProductPackageRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postProductPackageAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Perfil clínico", "Perfil clínico registrado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putProductPackage = (value: ProductPackageRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putProductPackageAPI(value);
    if (responseData.Error !== null) {
        dispatch(setMessageResponse(serverMessages(responseData)));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Perfil clínico", "Perfil clínico actualizado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postPlan = (value: PlanRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postPlanAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Plan", "Plan registrado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putPlan = (value: PlanRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putPlanAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Plan", "Plan actualizado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getContractSalesDocuments = (contractId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getContractSalesDocumentsAPI(contractId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getOrganizationLegalDocuments = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationLegalDocumentsAPI(organizationId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getLegalDocuments = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getLegalDocumentsAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getAllLegalDocuments = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getAllLegalDocumentsAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postLegalDocument = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postLegalDocumentAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Documento legal", "Documento legal registrado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putLegalDocument = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putLegalDocumentAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Documento legal", "Documento legal actualizado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getSalesDocuments = (organizationId?: string, ruc?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getSalesDocumentsAPI(organizationId, ruc);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postContractSalesDocument = (contractId: string, value: ContractSalesDocumentRequest): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postContractSalesDocumentAPI(contractId, value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Factura", "Factura registrada correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postContract = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postContractAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Contrato", "Contrato generado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getOrganizationClientData = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationClientDataAPI(organizationId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const prepareContractPayPhonePayment = (contractId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await prepareContractPayPhonePaymentAPI(contractId, value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const confirmContractPayPhonePayment = (contractId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await confirmContractPayPhonePaymentAPI(contractId, value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("PayPhone", "Pago confirmado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const preparePublicPayPhoneTrial = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await preparePublicPayPhoneTrialAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const preparePublicPayPhoneTrialFromBridge = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await preparePublicPayPhoneTrialFromBridgeAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const confirmPublicPayPhoneTrial = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await confirmPublicPayPhoneTrialAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getOrganizationCardTokens = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationCardTokensAPI(organizationId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getActiveOrganizationCardToken = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getActiveOrganizationCardTokenAPI(organizationId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const chargeContractWithCardToken = (contractId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await chargeContractWithCardTokenAPI(contractId, value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
        dispatch(toggleLoadingIndicator(false));
        return;
    } else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("PayPhone", "Cobro automatico registrado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const prepareOrganizationCardTokenPayPhone = (organizationId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await prepareOrganizationCardTokenPayPhoneAPI(organizationId, value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const confirmOrganizationCardTokenPayPhone = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await confirmOrganizationCardTokenPayPhoneAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const disableOrganizationCardToken = (cardTokenId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await disableOrganizationCardTokenAPI(cardTokenId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Tarjeta", "Tarjeta desactivada");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const confirmPublicPayPhonePayment = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await confirmPublicPayPhonePaymentAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getPendingPaymentRequestInvoices = (organizationId?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPendingPaymentRequestInvoicesAPI(organizationId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getOrganizationPaymentRequests = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationPaymentRequestsAPI(organizationId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getPendingCardValidationRequests = (organizationId?: string, search?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getPendingCardValidationRequestsAPI(organizationId, search);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const regeneratePaymentRequestPayPhone = (paymentRequestId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await regeneratePaymentRequestPayPhoneAPI(paymentRequestId, value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("PayPhone", "Link generado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postPaymentRequestSalesDocument = (paymentRequestId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postPaymentRequestSalesDocumentAPI(paymentRequestId, value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Factura", "Factura registrada correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const reversePaymentRequestPayPhone = (paymentRequestId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await reversePaymentRequestPayPhoneAPI(paymentRequestId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("PayPhone", "Pago reversado y contrato anulado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const cancelContract = (contractId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await cancelContractAPI(contractId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Contrato", responseData.Response?.message || "Contrato cancelado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const cancelSalesDocument = (salesDocumentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await cancelSalesDocumentAPI(salesDocumentId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Factura", "Factura anulada correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getOrganizationPaymentMethod = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationPaymentMethodAPI();
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getExpenseCategories = (onlyActive: boolean = true): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getExpenseCategoriesAPI(onlyActive);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postExpenseCategory = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postExpenseCategoryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Categoria de gasto", "Categoria registrada correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putExpenseCategory = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putExpenseCategoryAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Categoria de gasto", "Categoria actualizada correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getExpenses = (paramsValue: { from?: string; to?: string; categoryId?: string; organizationId?: string; status?: string } = {}): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getExpensesAPI(paramsValue);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postExpense = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postExpenseAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Gasto", "Gasto registrado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putExpense = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putExpenseAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Gasto", "Gasto actualizado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const cancelExpense = (id: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await cancelExpenseAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        openNotification("Gasto", "Gasto anulado correctamente");
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getExpenseDocument = (id: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getExpenseDocumentAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getFinancialMetrics = (paramsValue: { from?: string; to?: string; groupBy?: string; organizationId?: string } = {}): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getFinancialMetricsAPI(paramsValue);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getExpenseOptions = (organizationId?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getExpenseOptionsAPI(organizationId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getClientData = (ruc: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getClientDataAPI(ruc);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

const handleOrganizationManagementResponse = (responseData: any, dispatch: any, successMessage?: string) => {
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));
        dispatch(toggleLoadingIndicator(false));
        if (successMessage) {
            openNotification("Organizaciones", successMessage);
        }
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getOrganizationManagementOrganizations = (search?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementOrganizationsAPI(search);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getGlobalPhysicalSpaceTypes = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getGlobalPhysicalSpaceTypesAPI('ACTIVO');
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const postGlobalPhysicalSpaceType = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postGlobalPhysicalSpaceTypeAPI(value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Tipo de espacio creado correctamente");
};

export const putGlobalPhysicalSpaceType = (id: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putGlobalPhysicalSpaceTypeAPI(id, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Tipo de espacio actualizado correctamente");
};

export const inactivateGlobalPhysicalSpaceType = (id: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await inactivateGlobalPhysicalSpaceTypeAPI(id);
    return handleOrganizationManagementResponse(responseData, dispatch, "Tipo de espacio inactivado correctamente");
};

export const getGlobalDocumentTypes = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getGlobalDocumentTypesAPI();
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getProcedureDocumentTemplateTags = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getProcedureDocumentTemplateTagsAPI();
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const postGlobalDocumentType = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postGlobalDocumentTypeAPI(value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Tipo de documento creado correctamente");
};

export const putGlobalDocumentType = (id: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putGlobalDocumentTypeAPI(id, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Tipo de documento actualizado correctamente");
};

export const deleteGlobalDocumentType = (id: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteGlobalDocumentTypeAPI(id);
    return handleOrganizationManagementResponse(responseData, dispatch, "Tipo de documento eliminado correctamente");
};

export const getOrganizationProcedureDocuments = (organizationId: string, status?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationProcedureDocumentsAPI(organizationId, status);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const postOrganizationProcedureDocument = (organizationId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postOrganizationProcedureDocumentAPI(organizationId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Documento operativo creado correctamente");
};

export const putOrganizationProcedureDocument = (organizationId: string, documentId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putOrganizationProcedureDocumentAPI(organizationId, documentId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Documento operativo actualizado correctamente");
};

export const inactivateOrganizationProcedureDocument = (organizationId: string, documentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await inactivateOrganizationProcedureDocumentAPI(organizationId, documentId);
    return handleOrganizationManagementResponse(responseData, dispatch, "Documento operativo inactivado correctamente");
};

export const getOrganizationProcedureDocumentFile = (organizationId: string, documentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationProcedureDocumentFileAPI(organizationId, documentId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getOrganizationManagementCenters = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementCentersAPI(organizationId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getOrganizationManagementPlan = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementPlanAPI(organizationId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getOrganizationManagementContract = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementContractAPI(organizationId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const putOrganizationManagementContract = (organizationId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putOrganizationManagementContractAPI(organizationId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Contrato actualizado correctamente");
};

export const getContractBillingDocuments = (organizationId: string, contractId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getContractBillingDocumentsAPI(organizationId, contractId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const postContractBillingDocument = (organizationId: string, contractId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postContractBillingDocumentAPI(organizationId, contractId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "RIDE registrado correctamente");
};

export const putContractBillingDocument = (organizationId: string, contractId: string, documentId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putContractBillingDocumentAPI(organizationId, contractId, documentId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "RIDE actualizado correctamente");
};

export const deleteContractBillingDocument = (organizationId: string, contractId: string, documentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteContractBillingDocumentAPI(organizationId, contractId, documentId);
    return handleOrganizationManagementResponse(responseData, dispatch, "RIDE anulado correctamente");
};

export const getContractBillingDocumentFile = (organizationId: string, contractId: string, documentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getContractBillingDocumentFileAPI(organizationId, contractId, documentId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getContractBillingPayments = (organizationId: string, contractId: string, documentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getContractBillingPaymentsAPI(organizationId, contractId, documentId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const postContractBillingPayment = (organizationId: string, contractId: string, documentId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postContractBillingPaymentAPI(organizationId, contractId, documentId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Pago registrado correctamente");
};

export const putContractBillingDocumentMora = (organizationId: string, contractId: string, documentId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putContractBillingDocumentMoraAPI(organizationId, contractId, documentId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Factura marcada en mora");
};

export const deleteContractBillingPayment = (organizationId: string, contractId: string, documentId: string, paymentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteContractBillingPaymentAPI(organizationId, contractId, documentId, paymentId);
    return handleOrganizationManagementResponse(responseData, dispatch, "Pago reversado correctamente");
};

export const getContractBillingPaymentFile = (organizationId: string, contractId: string, documentId: string, paymentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getContractBillingPaymentFileAPI(organizationId, contractId, documentId, paymentId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getContractDocuments = (organizationId: string, contractId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getContractDocumentsAPI(organizationId, contractId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const postContractDocument = (organizationId: string, contractId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postContractDocumentAPI(organizationId, contractId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Documento del contrato cargado correctamente");
};

export const deleteContractDocument = (organizationId: string, contractId: string, documentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteContractDocumentAPI(organizationId, contractId, documentId);
    return handleOrganizationManagementResponse(responseData, dispatch, "Documento del contrato anulado correctamente");
};

export const getContractDocumentFile = (organizationId: string, contractId: string, documentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getContractDocumentFileAPI(organizationId, contractId, documentId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const postContractBillingDueEvaluation = (organizationId: string, contractId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postContractBillingDueEvaluationAPI(organizationId, contractId);
    return handleOrganizationManagementResponse(responseData, dispatch, "Vencimientos evaluados correctamente");
};

export const getContractBillingMetrics = (organizationId: string, contractId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getContractBillingMetricsAPI(organizationId, contractId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const putContractBillingSalesDocument = (organizationId: string, contractId: string, documentId: string, salesDocumentId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putContractBillingSalesDocumentAPI(organizationId, contractId, documentId, salesDocumentId);
    return handleOrganizationManagementResponse(responseData, dispatch, "Factura vinculada con sales_document correctamente");
};

export const getOrganizationManagementStaff = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementStaffAPI(organizationId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getOrganizationManagementStaffRoles = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementStaffRolesAPI(organizationId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getOrganizationManagementStaffAudit = (
    organizationId: string,
    query: Parameters<typeof getOrganizationManagementStaffAuditAPI>[1] = {}
): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementStaffAuditAPI(organizationId, query);
    return handleOrganizationManagementResponse(responseData, dispatch);
};


export const postOrganizationManagementStaff = (organizationId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postOrganizationManagementStaffAPI(organizationId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Personal clinico creado correctamente");
};

export const putOrganizationManagementStaff = (organizationId: string, staffId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putOrganizationManagementStaffAPI(organizationId, staffId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Personal clinico actualizado correctamente");
};

export const getOrganizationMedicalFees = (organizationId: string, query: Parameters<typeof getOrganizationMedicalFeesAPI>[1] = {}): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationMedicalFeesAPI(organizationId, query);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const postOrganizationMedicalFee = (organizationId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postOrganizationMedicalFeeAPI(organizationId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Honorario médico creado correctamente");
};

export const putOrganizationMedicalFee = (organizationId: string, id: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putOrganizationMedicalFeeAPI(organizationId, id, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Honorario médico actualizado correctamente");
};

export const deleteOrganizationMedicalFee = (organizationId: string, id: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteOrganizationMedicalFeeAPI(organizationId, id);
    return handleOrganizationManagementResponse(responseData, dispatch, "Honorario médico inactivado correctamente");
};

export const getOrganizationCenterSpecialities = (centerId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationCenterSpecialitiesAPI(centerId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const putOrganization = (value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putOrganizationAPI(value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Imagen de la organización actualizada correctamente");
};

export const getOrganizationManagementSpecialities = (organizationId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementSpecialitiesAPI(organizationId);
    if (responseData.Error !== null) {
        handleOrganizationManagementResponse(responseData, dispatch);
        throw new Error('No se pudieron cargar las especialidades asociadas a la organización.');
    }
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const putOrganizationManagementSpeciality = (organizationId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putOrganizationManagementSpecialityAPI(organizationId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Especialidad de la organizacion actualizada correctamente");
};

export const postOrganizationManagementCenter = (organizationId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postOrganizationManagementCenterAPI(organizationId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Centro creado correctamente");
};

export const putOrganizationManagementCenter = (centerId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putOrganizationManagementCenterAPI(centerId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Centro actualizado correctamente");
};

export const putOrganizationCenterSpeciality = (centerId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putOrganizationCenterSpecialityAPI(centerId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Especialidad de la sucursal actualizada correctamente");
};

export const getOrganizationManagementProducts = (organizationId: string, search?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementProductsAPI(organizationId, search);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getOrganizationManagementWarehousesByCenter = (centerId: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementWarehousesByCenterAPI(centerId);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const postOrganizationManagementWarehouse = (centerId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postOrganizationManagementWarehouseAPI(centerId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Bodega creada correctamente");
};

export const putOrganizationManagementWarehouse = (warehouseId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putOrganizationManagementWarehouseAPI(warehouseId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Bodega actualizada correctamente");
};

export const getOrganizationManagementWarehouseStock = (warehouseId: string, lowStockOnly: boolean = false): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementWarehouseStockAPI(warehouseId, lowStockOnly);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const postOrganizationManagementInventoryMovement = (warehouseId: string, value: Object): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await postOrganizationManagementInventoryMovementAPI(warehouseId, value);
    return handleOrganizationManagementResponse(responseData, dispatch, "Movimiento registrado correctamente");
};

export const getOrganizationManagementInventoryMovements = (warehouseId: string, productId?: string, from?: string, to?: string): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementInventoryMovementsAPI(warehouseId, productId, from, to);
    return handleOrganizationManagementResponse(responseData, dispatch);
};

export const getOrganizationManagementInventoryMovementReasons = (): AppThunk => async (dispatch) => {
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getOrganizationManagementInventoryMovementReasonsAPI();
    return handleOrganizationManagementResponse(responseData, dispatch);
};
